// Types
import { grey } from '../../../common/styles/colours';
export var ParagraphStylePropertiesByVariant = {
    default: function (theme) {
        var _a;
        return ({
            color: (_a = theme.contentPrimary) !== null && _a !== void 0 ? _a : grey[900],
        });
    },
};
//# sourceMappingURL=ParagraphStylePropertiesByVariant.js.map